<template>
    <div class="login">
      <div class="login-weaper">
        <a href="http://www.shqpfz.com:12700" title="点击跳转">
        <div class="login-right">
            <div class="login-main">
              <h2 class="login-title">青可测</h2>
            </div>
        </div>
        </a>
      </div>
      <div class="vue-particles">
      </div>
      <div class="bottom-nav">
        <span style="margin-right: 80px;">公安备案号：沪公网安备31011802004940号 <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2024066121号</a></span><span style="margin-right: 80px;">地址：上海市青浦区外青松公路6666弄28号</span><span>电话：18502117661</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        quotations: {},
        isView: false,
      
      };
    },
    computed: {
      // 获取布局配置信息
    //   getThemeConfig() {
    //     return this.$store.state.themeConfig.themeConfig;
    //   },
    },
    created() {
  
    },
    mounted() {
  
    },
    methods: {
      
    },

  };
  </script>
  
  <style scoped lang="scss">
  .login {
      height: 100%;
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: relative;
      .vue-particles {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 95%;
          // background: radial-gradient(ellipse at top left, rgba(105, 155, 200, 1) 0%, rgba(181, 197, 216, 1) 57%);
          background-image: url('../../assets/image/Group 278.png');
          background-size: 100% 100% no-repeat;
      }
      .login-weaper {
          position: fixed;
          top: 45%;
          left: 70%;
          height: 150px;
          display: flex;
          box-sizing: border-box;
          position: relative;
          z-index: 1;
          border: none;
          // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
          .login-left {
              width: 291px;
              padding: 10px;
              font-size: 16px;
              color: #fff;
              position: relative;
              background-color: rgba(64, 158, 255, 0.8);
              display: flex;
              flex-direction: column;
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
    
          }
          .login-right {
              width: 241px;
              padding: 10px;
              position: relative;
              align-items: center;
              display: flex;
              background-color: rgba(255, 255, 255, 1);
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
              border-radius: 24px;
              .login-main {
                  margin: 0 auto;
                  width: 70%;
                  .login-title {
                      // color: #333;
                      margin-bottom: 40px;
                      // font-weight: 500;
                      // font-size: 22px;
                      text-align: center;
                      letter-spacing: 4px;
                      font-weight: 600;
                      font-size: 30px;
                      line-height: 42px;
                      /* identical to box height */
                      letter-spacing: 2.5px;
                      /* 深色 */
                      color: #336de8;
                  }

              }
          }
       }
      .bottom-nav {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
        background-color: hsl(0, 0%, 93%);
        bottom: 0;
        
      }
      .bottom-nav span {
            font-size: 18px;
            color: black;
        }
      .bottom-nav a {
            color: black;
        }
  }
  </style>
  